export const resources = {
  ja: {
    console: {
      common: {
        actions: {
          cancel: "キャンセル",
          exportCsv: "CSV形式でエクスポート",
          login: "ログイン",
          loggingIn: "ログイン中...",
          refund: "返金する",
          refunding: "返金中...",
          reload: "リロード",
        },
        errors: {
          loginFailed: "ログインに失敗しました。",
        },
        fields: {
          loginId: "ログインID",
          password: "パスワード",
        },
        password: {
          hide: "パスワードを隠す",
          show: "パスワードを表示",
        },
        status: {
          loading: "読み込み中...",
        },
        validation: {
          loginIdRequired: "ログインIDを入力してください。",
          passwordRequired: "パスワードを入力してください。",
        },
      },
      login: {
        company: {
          description: "事業者アカウントでログインしてください。",
          title: "事業者コンソール",
        },
        store: {
          description: "店舗アカウントでログインしてください。",
          title: "店舗コンソール",
        },
      },
      store: {
        dashboard: {
          googleMaps: "Google Maps",
          iconAlt: "{{storeName}} の店舗アイコン",
          labels: {
            address: "登録住所",
            location: "位置情報",
            name: "店舗名",
            qrCodeId: "QRコードID",
            status: "ステータス",
          },
          notRegistered: "登録なし",
          pageTitle: "登録情報",
          sections: {
            basicInfo: "基本情報",
            icon: "店舗アイコン",
          },
          status: {
            active: "利用中",
            suspended: "利用停止中",
          },
        },
        transactions: {
          actions: {
            dateRangeLabel: "日時：{{limit}} ~ {{offset}}",
            refundDisabled: "この店舗では返金操作が無効化されています。",
          },
          columns: {
            action: "操作",
            age: "年齢",
            dateTime: "日時",
            gender: "性別",
            points: "ポイント",
            qrTag: "QRコードタグ",
            transactionId: "取引ID",
            userId: "支払ユーザーID",
          },
          csv: {
            filenamePrefix: "取引履歴",
          },
          dialog: {
            description:
              "取引ID {{transactionGroupId}} を返金します。この操作は取り消せません。",
            title: "返金を実行しますか？",
          },
          empty: {
            description: "指定した期間に該当する取引はありません。",
            title: "取引履歴はありません",
          },
          pageTitle: "取引履歴",
          summary: {
            salesAmount: "ポイント売上合計",
            transactionCount: "ポイント利用件数",
            transactionCountValue: "{{count}}件",
          },
          table: {
            action: {
              refund: "返金",
              refunded: "返金済み",
              settled: "締め済み",
              unavailable: "操作不可",
            },
            countLabel: "全{{count}}件",
            gender: {
              female: "女性",
              male: "男性",
              undefined: "未定義",
              unspecified: "不明",
            },
            saleStatus: {
              confirmed: "売上確定",
              settled: "締め済み",
            },
          },
          toasts: {
            loadFailed: "取引履歴の取得に失敗しました",
            refundFailed: "取引の返金に失敗しました",
            refundSuccess: "取引の返金に成功しました",
          },
        },
      },
    },
  },
} as const;
